































import { namespace } from 'vuex-class';
import { Vue, Component, Prop } from 'vue-property-decorator';

import { ICustomer } from '@/interfaces/Customer';

const CustomerModule = namespace('App/Customer');

@Component
export default class KoinPaymentFeedback extends Vue {
  @Prop()
  private readonly statusPayment!: string;

  @CustomerModule.State
  private customer!: ICustomer;

  private get customerEmail() {
    return this.customer && this.customer.email;
  }

  private get isStatusWaitingPayment() {
    return this.statusPayment === 'waiting-for-payment';
  }

  private get title() {
    return this.statusPayment === 'waiting-for-payment' ? this.$t('App.Checkout.koin.waitingPayment.title') : this.$t('App.Checkout.koin.underReview.title');
  }

  private get description() {
    return this.isStatusWaitingPayment ? this.$t('App.Checkout.koin.waitingPayment.description', [this.customerEmail]) : this.$t('App.Checkout.koin.underReview.description');
  }
}
